export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            有好的电影资源推荐？发现片源问题？欢迎随时联系我们
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="p-5 rounded-xl bg-background-50 border border-secondary-100/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">
                资源投稿
              </h3>
              <p className="text-xs text-foreground-500">
                movie@peanutcinema.com
              </p>
            </div>

            <div className="p-5 rounded-xl bg-background-50 border border-secondary-100/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-bug-line text-lg"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">
                问题反馈
              </h3>
              <p className="text-xs text-foreground-500">
                feedback@peanutcinema.com
              </p>
            </div>

            <div className="p-5 rounded-xl bg-background-50 border border-secondary-100/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-200 text-secondary-700 mx-auto mb-3">
                <i className="ri-hand-heart-line text-lg"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">
                商务合作
              </h3>
              <p className="text-xs text-foreground-500">
                biz@peanutcinema.com
              </p>
            </div>
          </div>

          <p className="text-xs text-foreground-400">
            工作时间：周一至周日 9:00 - 22:00 · 通常24小时内回复
          </p>
        </div>
      </div>
    </section>
  );
}